import Vue from 'vue'
import DepartmentDialogSelector from './department-dialog-selector.vue'
import DepartmentDialogSelectorInstance from './department-dialog-selector-instance.vue'

DepartmentDialogSelector.install = function (Vue) {
	Vue.component(DepartmentDialogSelector.name, DepartmentDialogSelector);
}

export default DepartmentDialogSelector;

class DepartmentInstance {
    constructor() {
		this.instance = null;
	}
    init() {
        // 初始化实例，挂载dom
		const VueInstance = Vue || window.Vue;
		let shopComponent = VueInstance.extend(DepartmentDialogSelectorInstance);
        this.instance = new shopComponent({
			el: document.createElement('div'),
		}).$mount();
		document.body.appendChild(this.instance.$el);
    }
    getInstance() {
		// 返回实例
		return this.instance;
	}
	// 外部调用方法
	show(params) {
		return new Promise((resolve, reject) => {
			if (!this.instance) {
				this.init();
			}
			Object.assign(this.instance, {resolve, reject})
			this.instance.show(params);
		})
		
	}
}

export const DepartmentSelectModal = new DepartmentInstance();
window.departmentSelectModal = DepartmentSelectModal;